import React from "react";

const Page1 = () => {
  return (
   <div>
  <div classname="site-mobile-menu site-navbar-target">
    <div classname="site-mobile-menu-header">
      <div classname="site-mobile-menu-close">
        <span classname="icofont-close js-menu-toggle">
        </span></div>
    </div>
    <div classname="site-mobile-menu-body">
    </div>
    <nav classname="site-nav dark mb-5 site-navbar-target">
      <div classname="container">
        <div classname="site-navigation">
          <a href="index.html" classname="logo m-0">
            Space<span classname="text-primary">.</span>
          </a>
          <ul classname="js-clone-nav d-none d-lg-inline-none site-menu float-right">
            <li>
              <a href="#home-section" classname="nav-link active">
                Home
              </a>
            </li>
            <li>
              <a href="#portfolio-section">Portfolio</a>
            </li>
            <li classname="has-children">
              <a href="#about-section">About</a>
              <ul classname="dropdown">
                <li>
                  <a href="elements.html">Elements</a>
                </li>
                <li classname="has-children">
                  <a href="#">Menu Two</a>
                  <ul classname="dropdown">
                    <li>
                      <a href="#">Sub Menu One</a>
                    </li>
                    <li>
                      <a href="#">Sub Menu Two</a>
                    </li>
                    <li>
                      <a href="#">Sub Menu Three</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#">Menu Three</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="services.html">Services</a>
            </li>
            <li>
              <a href="contact.html">Contact us</a>
            </li>
          </ul>
          <a href="#" classname="burger ml-auto float-right site-menu-toggle js-menu-toggle d-inline-block d-lg-inline-block" data-toggle="collapse" data-target="#main-navbar">
            <span>
            </span></a>
        </div>
      </div>
    </nav>
    <div classname="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
      <div classname="container">
        <div classname="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
          <div classname="portfolio-single-inner">
            <h2 classname="heading-portfolio-single-h2 text-black">
              Slider Portfolio Details
            </h2>
            <div classname="row justify-content-between mb-5">
              <div classname="col-12 mb-4">
                <div classname="owl-carousel single-slider">
                  <figure classname="mb-4">
                    <img src="images/portfolio_1.jpg" alt="Image" classname="img-fluid" />
                  </figure>
                  <figure classname="mb-4">
                    <img src="images/portfolio_2.jpg" alt="Image" classname="img-fluid" />
                  </figure>
                </div>
              </div>
              <div classname="col-12 my-5">
                <div classname="row">
                  <div classname="col-sm-6 col-md-6 col-lg-3">
                    <div classname="detail-v1">
                      <span classname="detail-label">Project Date</span>
                      <span classname="detail-val">March 9th, 2020</span>
                    </div>
                  </div>
                  <div classname="col-sm-6 col-md-6 col-lg-3">
                    <div classname="detail-v1">
                      <span classname="detail-label">Role</span>
                      <span classname="detail-val">
                        <a href="#">Identity</a>, <a href="#">Web Design</a>
                      </span>
                    </div>
                  </div>
                  <div classname="col-sm-6 col-md-6 col-lg-3">
                    <div classname="detail-v1">
                      <span classname="detail-label">Client</span>
                      <span classname="detail-val">Untree.co</span>
                    </div>
                  </div>
                  <div classname="col-sm-6 col-md-6 col-lg-3">
                    <div classname="detail-v1">
                      <span classname="detail-label">Visit</span>
                      <span classname="detail-val">
                        <a href="https://untree.co">https://untree.co/</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div classname="col-md-6">
                <p>
                  Far far away, behind the word mountains, far from the
                  countries Vokalia and Consonantia, there live the blind
                  texts. Separated they live in Bookmarksgrove right at the
                  coast of the Semantics, a large language ocean. A small
                  river named Duden flows by their place and supplies it with
                  the necessary regelialia. It is a paradisematic country, in
                  which roasted parts of sentences fly into your mouth.
                </p>
              </div>
              <div classname="col-md-6">
                <p>
                  Even the all-powerful Pointing has no control about the
                  blind texts it is an almost unorthographic life One day
                  however a small line of blind text by the name of Lorem
                  Ipsum decided to leave for the far World of Grammar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div classname="site-footer">
      <div classname="container">
        <div classname="row">
          <div classname="col-lg-3">
            <div classname="widget">
              <h3>Home</h3>
              <ul classname="list-unstyled float-left links">
                <li>
                  <a href="#">Untree.co</a>
                </li>
                <li>
                  <a href="#">About us</a>
                </li>
                <li>
                  <a href="#">Projects</a>
                </li>
                <li>
                  <a href="#">Services</a>
                </li>
                <li>
                  <a href="#">Terms</a>
                </li>
                <li>
                  <a href="#">Privacy</a>
                </li>
              </ul>
            </div>{'{'}" "{'}'}
            {'{'}/* /.widget */{'}'}
          </div>{'{'}" "{'}'}
          {'{'}/* /.col-lg-3 */{'}'}
          <div classname="col-lg-3">
            <div classname="widget">
              <h3>Projects</h3>
              <ul classname="list-unstyled float-left links">
                <li>
                  <a href="#">HTML5</a>
                </li>
                <li>
                  <a href="#">CSS3</a>
                </li>
                <li>
                  <a href="#">Untree.co</a>
                </li>
                <li>
                  <a href="#">Free Templates</a>
                </li>
                <li>
                  <a href="#">WordPress Themes</a>
                </li>
              </ul>
            </div>{'{'}" "{'}'}
            {'{'}/* /.widget */{'}'}
          </div>{'{'}" "{'}'}
          {'{'}/* /.col-lg-3 */{'}'}
          <div classname="col-lg-3">
            <div classname="widget">
              <h3>Services</h3>
              <ul classname="list-unstyled float-left links">
                <li>
                  <a href="#">Untree.co</a>
                </li>
                <li>
                  <a href="#">jQuery</a>
                </li>
                <li>
                  <a href="#">Bootstrap</a>
                </li>
                <li>
                  <a href="#">Freebies</a>
                </li>
              </ul>
            </div>{'{'}" "{'}'}
            {'{'}/* /.widget */{'}'}
          </div>{'{'}" "{'}'}
          {'{'}/* /.col-lg-3 */{'}'}
          <div classname="col-lg-3">
            <div classname="widget">
              <h3>Contact</h3>
              <address>43 Raymouth Rd. Baltemoer, London 3910</address>
              <ul classname="list-unstyled links mb-4">
                <li>
                  <a href="tel://11234567890">+1(123)-456-7890</a>
                </li>
                <li>
                  <a href="tel://11234567890">+1(123)-456-7890</a>
                </li>
                <li>
                  <a href="mailto:info@mydomain.com">info@mydomain.com</a>
                </li>
              </ul>
              <h3>Connect</h3>
              <ul classname="list-unstyled social">
                <li>
                  <a href="#">
                    <span classname="icon-instagram">
                    </span></a>
                </li>
                <li>
                  <a href="#">
                    <span classname="icon-twitter">
                    </span></a>
                </li>
                <li>
                  <a href="#">
                    <span classname="icon-facebook">
                    </span></a>
                </li>
                <li>
                  <a href="#">
                    <span classname="icon-linkedin">
                    </span></a>
                </li>
                <li>
                  <a href="#">
                    <span classname="icon-pinterest">
                    </span></a>
                </li>
                <li>
                  <a href="#">
                    <span classname="icon-dribbble">
                    </span></a>
                </li>
              </ul>
            </div>{'{'}" "{'}'}
            {'{'}/* /.widget */{'}'}
          </div>{'{'}" "{'}'}
          {'{'}/* /.col-lg-3 */{'}'}
        </div>{'{'}" "{'}'}
        {'{'}/* /.row */{'}'}
        <div classname="row mt-5">
          <div classname="col-12 text-center">
            <p classname=" mb-0">
              © 2020. All Rights Reserved. Design by{'{'}" "{'}'}
              <a href="https://untree.co/" target="_blank" classname>
                <strong>Untree.co</strong>
              </a>{'{'}" "{'}'}
              Distributed By <a href="https://themewagon.com">ThemeWagon</a>{'{'}" "{'}'}
            </p>
            <p classname>
              <span classname="mx-2">
                Twitter <a href="https://twitter.com/untree_co">@Untree_co</a>
              </span>
              <span>•</span>
              <span classname="mx-2">
                Facebook{'{'}" "{'}'}
                <a href="https://web.facebook.com/Untree.co">@Untree.co</a>
              </span>
            </p>
          </div>
        </div>
      </div>{'{'}" "{'}'}
      {'{'}/* /.container */{'}'}
    </div>
  </div>
</div>

  );
};

export default Page1;
